import { MarketplaceTypeEnum } from '../../../enums/MarketplaceTypeEnum';

export class SaveOrderImportInput {
  pathToFile: string;
  notificationEmails?: string | null;
  marketplaceType: MarketplaceTypeEnum;
  userId?: number | null;
}